module.exports = __webpack_public_path__ + "static/img/fish27.37d30b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish27.png
// module id = 1iTy
// module chunks = 0